import Vue from 'vue';
import { NotificationsState } from './state';
import { MutationTree } from 'vuex';

const mutations: MutationTree<NotificationsState> = {
  SET_FEATURED_NOTIFICATIONS(state, notifications: any[]) {
    (notifications || []).map((notification) =>
      Vue.set(state.featuredNotifications, notification.id.toString(), {
        ...state.featuredNotifications[notification.id],
        ...notification,
      }),
    );
  },
  SET_NOTIFICATION(state, notification: any) {
    Vue.set(state.notifications, notification.id.toString(), {
      ...state.notifications[notification.id],
      ...notification,
    });
    Vue.set(state.featuredNotifications, notification.id.toString(), {
      ...state.featuredNotifications[notification.id],
      ...notification,
    });
  },
  SET_URL_BLOCKLIST(state, blockList: any[]) {
    (blockList || []).map((blockedUrl) =>
      Vue.set(state.blockList, blockedUrl.id.toString(), {
        ...state.blockList[blockedUrl.id],
        ...blockedUrl,
      }),
    );
  },
  SET_FEATURED_NOTIFICATION(state, notification: any) {
    state.featuredNotifications[notification.id] = notification;
  },
};

export default mutations;
